import {
  AiOutlineFund,
  AiOutlineHome,
  AiOutlineLogout,
  AiOutlineMail,
  AiOutlineNotification,
  AiOutlinePayCircle,
  AiOutlinePercentage,
  AiOutlineScissor,
  AiOutlineSetting,
  AiOutlineSolution,
  AiOutlineTeam,
  AiOutlineUserAdd,
} from "react-icons/ai";

export const adminMenu = [
  {
    title: "Dashboard",
    path: "/admin/dashboard",
    icon: <AiOutlineHome />,
    permission: "all",
  },
  {
    title: "User Management",
    path: "/admin/user-management",
    icon: <AiOutlineSolution />,
    permission: "user",
  },
  {
    title: "Campuses",
    path: "/admin/campuses",
    icon: <AiOutlineFund />,
    permission: "campus",
  },
  {
    title: "Payment Links",
    path: "/admin/payment-links",
    icon: <AiOutlinePercentage />,
    permission: "payments",
  },
  {
    title: "Praise Reports",
    path: "/admin/praise-reports",
    icon: <AiOutlineFund />,
    permission: "testimony",
  },
  {
    title: "Gallery",
    path: "/admin/gallery",
    icon: <AiOutlineUserAdd />,
    permission: "gallery",
  },
  {
    title: "Sermons",
    path: "/admin/sermons",
    icon: <AiOutlineTeam />,
    permission: "store",
  },
  {
    title: "Library",
    path: "/admin/library",
    icon: <AiOutlineTeam />,
    permission: "store",
  },
  {
    title: "Children",
    path: "/admin/children",
    icon: <AiOutlineTeam />,
    permission: "store",
  },
  {
    title: "Events",
    path: "/admin/events",
    icon: <AiOutlineScissor />,
    permission: "event",
  },
  {
    title: "Appointments",
    path: "/admin/appointments",
    icon: <AiOutlineScissor />,
    permission: "appointment",
  },
  {
    title: "Family Processes",
    path: "/admin/family-processes",
    icon: <AiOutlineScissor />,
    permission: "family-process",
  },
  {
    title: "Cells",
    path: "/admin/all-cells",
    icon: <AiOutlineScissor />,
    permission: "cell",
  },
  {
    title: "Categories",
    path: "/admin/categories",
    icon: <AiOutlineScissor />,
    permission: "category",
  },
  {
    title: "Tickets",
    path: "/admin/tickets",
    icon: <AiOutlineMail />,
    permission: "support",
  },
  {
    title: "Broadcasts",
    path: "/admin/broadcast",
    icon: <AiOutlineNotification />,
    permission: "admin",
  },
  { title: "Logout", path: "/", icon: <AiOutlineLogout />, permission: "all" },
];

export const otherProtectedPages = [
  {
    path: "/admin/forms/",
    permission: "family-process",
  },
  { path: "/admin/form-details/", permission: "family-process" },
];

export const userMenu = [
  {
    title: "Home",
    path: "/",
  },
  {
    title: "About Us",
    path: "/about",
  },
  {
    title: "Churches",
    path: "/churches",
  },
  {
    title: "COZA Give",
    path: "/coza-give",
  },
  // {
  //   title: "COZA TV",
  //   path: "/tv",
  // },
  {
    title: "Contact Us",
    path: "/support",
  },
];

export const floatingMenu = [
  {
    title: "Sermon",
    path: "/sermon",
    icon: (
      <svg
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="white"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M17.4415 5.54664H12.5007V0H7.50058V5.54664H1.93347V10.547H7.50058V20H12.5007V10.5467L18.0665 10.547V5.54664H17.4415ZM16.8165 9.29672H11.2507V18.75H8.75062V9.29672H3.18347V6.79668H8.75058V1.24969H11.2506V6.79664H16.8165L16.8165 9.29672Z"
          fill="white"
        />
      </svg>
    ),
    activeIcon: (
      <svg
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M11.875 6.04156V0H8.125V6.04156H2.1875V9.79156H8.125V20H11.875V9.79156H17.8125V6.04156H11.875Z"
          fill="white"
        />
      </svg>
    ),
  },
  {
    title: "Library",
    path: "/library",
    icon: (
      <svg
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M12.196 5.56267C12.0884 5.13252 12.3502 4.69608 12.7813 4.58798C12.7814 4.58795 12.7816 4.58791 12.7817 4.58788L14.1832 4.23875L14.1838 4.23859C14.6131 4.13118 15.0502 4.39278 15.1584 4.82452C15.1584 4.82465 15.1584 4.82478 15.1585 4.82491L17.9155 15.8838C18.0227 16.3137 17.7604 16.751 17.3293 16.859C17.3292 16.859 17.3292 16.859 17.3292 16.859L15.9277 17.2081L15.9276 17.2081C15.4972 17.3154 15.0606 17.0533 14.9533 16.6225L14.9532 16.6224L12.1961 5.56307L12.196 5.56267ZM4.27836 2.76713C4.722 2.76713 5.08238 3.12751 5.08238 3.57115V16.4283C5.08238 16.8719 4.722 17.2323 4.27836 17.2323H2.85765C2.4135 17.2323 2.05363 16.8721 2.05363 16.4283V3.57115C2.05363 3.12731 2.4135 2.76713 2.85765 2.76713H4.27836ZM9.27836 2.76713C9.722 2.76713 10.0824 3.12751 10.0824 3.57115V16.4283C10.0824 16.8719 9.722 17.2323 9.27836 17.2323H7.85336C7.40921 17.2323 7.04935 16.8721 7.04935 16.4283V3.57115C7.04935 3.12731 7.40921 2.76713 7.85336 2.76713H9.27836Z"
          stroke="white"
          strokeWidth="1.24911"
        />
      </svg>
    ),
    activeIcon: (
      <svg
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M4.27836 2.14258C5.06693 2.14258 5.70693 2.78258 5.70693 3.57115V16.4283C5.70693 17.2169 5.06693 17.8569 4.27836 17.8569H2.85765C2.06836 17.8569 1.42908 17.2169 1.42908 16.4283V3.57115C1.42908 2.78258 2.06836 2.14258 2.85765 2.14258H4.27836ZM9.27836 2.14258C10.0669 2.14258 10.7069 2.78258 10.7069 3.57115V16.4283C10.7069 17.2169 10.0669 17.8569 9.27836 17.8569H7.85336C7.06408 17.8569 6.42479 17.2169 6.42479 16.4283V3.57115C6.42479 2.78258 7.06408 2.14258 7.85336 2.14258H9.27836ZM15.7644 4.67344L18.5215 15.7327C18.7122 16.4977 18.2458 17.2734 17.4808 17.4649L16.0786 17.8142C15.3136 18.0049 14.5379 17.5391 14.3472 16.7734L11.5901 5.71415C11.3986 4.94844 11.8651 4.17344 12.6301 3.98201L14.0322 3.63272C14.7972 3.44129 15.5729 3.90772 15.7644 4.67344Z"
          fill="white"
        />
      </svg>
    ),
  },
  {
    title: "Store",
    path: "/store",
    icon: (
      <svg
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M18.1253 7.50107C18.1253 7.43363 18.1144 7.36663 18.0928 7.30273L17.1861 4.58435C16.9245 3.79542 16.4208 3.10904 15.7466 2.62282C15.0725 2.13659 14.2622 1.87526 13.4311 1.87598H6.56927C5.73808 1.87526 4.92782 2.13659 4.25368 2.62282C3.57955 3.10904 3.07585 3.79542 2.81421 4.58435L1.90753 7.30356C1.88604 7.3672 1.87507 7.43391 1.87503 7.50107C1.87781 8.28364 2.17536 9.03644 2.70838 9.60944V15.0012C2.70926 15.8297 3.03879 16.6241 3.62466 17.21C4.21053 17.7958 5.00488 18.1254 5.83343 18.1262H8.98098V15.0012C8.98098 14.7249 9.09073 14.46 9.28608 14.2646C9.48143 14.0693 9.74639 13.9595 10.0227 13.9595C10.2989 13.9595 10.5639 14.0693 10.7592 14.2646C10.9546 14.46 11.0643 14.7249 11.0643 15.0012V18.1262H14.1669C14.9954 18.1254 15.7898 17.7958 16.3757 17.21C16.9615 16.6241 17.2911 15.8297 17.2919 15.0012V9.61027C17.8252 9.03706 18.1227 8.28393 18.1253 7.50107ZM4.00006 4.97769C4.17941 4.43822 4.52416 3.96896 4.98536 3.63656C5.44656 3.30416 6.00077 3.12552 6.56927 3.126H13.4311C13.9996 3.12552 14.5538 3.30416 15.015 3.63656C15.4762 3.96896 15.8209 4.43822 16.0003 4.97769L16.8728 7.59524C16.8544 8.07613 16.6495 8.53096 16.3015 8.86339C15.9535 9.19581 15.4898 9.3797 15.0086 9.3761C14.6015 9.37968 14.2024 9.26295 13.8614 9.04057C13.5204 8.81818 13.2527 8.50005 13.0919 8.12608C13.0487 8.00383 12.9685 7.89805 12.8625 7.8234C12.7565 7.74874 12.6299 7.7089 12.5002 7.7094C12.3703 7.70977 12.2438 7.75069 12.1384 7.82643C12.0329 7.90218 11.9537 8.00898 11.9119 8.13191C11.7496 8.5033 11.4826 8.81932 11.1435 9.04125C10.8044 9.26318 10.4079 9.38138 10.0027 9.38138C9.59739 9.38138 9.20091 9.26318 8.8618 9.04125C8.5227 8.81932 8.25568 8.5033 8.09346 8.13191C8.05135 8.00817 7.9714 7.90079 7.86493 7.82497C7.75845 7.74915 7.63083 7.70873 7.50012 7.7094C7.37075 7.70925 7.24451 7.74925 7.13883 7.82388C7.03315 7.89851 6.95324 8.0041 6.91011 8.12608C6.74926 8.50005 6.48154 8.81818 6.14055 9.04057C5.79957 9.26295 5.40049 9.37968 4.99341 9.3761C4.5119 9.38013 4.04775 9.19644 3.69941 8.86397C3.35108 8.5315 3.14595 8.07642 3.12755 7.59524L4.00006 4.97769ZM14.1669 16.8762H12.3144V15.0012C12.3144 14.3934 12.0729 13.8105 11.6431 13.3807C11.2134 12.9509 10.6305 12.7095 10.0227 12.7095C9.41486 12.7095 8.83196 12.9509 8.40218 13.3807C7.9724 13.8105 7.73096 14.3934 7.73096 15.0012V16.8762H5.83343C5.33627 16.8758 4.85961 16.6781 4.50807 16.3265C4.15653 15.975 3.95884 15.4983 3.9584 15.0012V10.4353C4.28928 10.5579 4.63888 10.6225 4.99175 10.6261C5.46331 10.6235 5.92929 10.5239 6.36079 10.3337C6.79228 10.1435 7.18008 9.8666 7.50012 9.52027C7.81751 9.86859 8.20409 10.1468 8.63515 10.3372C9.06621 10.5276 9.53226 10.626 10.0035 10.626C10.4747 10.626 10.9408 10.5276 11.3718 10.3372C11.8029 10.1468 12.1895 9.86859 12.5069 9.52027C12.8261 9.86579 13.2129 10.1422 13.6431 10.3324C14.0734 10.5226 14.5381 10.6226 15.0086 10.6261C15.3614 10.6225 15.711 10.5579 16.0419 10.4353V15.0012C16.0415 15.4983 15.8438 15.975 15.4923 16.3265C15.1407 16.6781 14.664 16.8758 14.1669 16.8762Z"
          fill="white"
        />
      </svg>
    ),
    activeIcon: (
      <svg
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M17.0836 15.0009C17.0836 15.7744 16.7763 16.5163 16.2293 17.0633C15.6823 17.6103 14.9405 17.9176 14.1669 17.9176H12.1085V15.8342C12.1085 15.2817 11.889 14.7517 11.4983 14.361C11.1076 13.9703 10.5777 13.7508 10.0252 13.7508C9.47262 13.7508 8.94271 13.9703 8.55201 14.361C8.1613 14.7517 7.9418 15.2817 7.9418 15.8342V17.9176H5.83343C5.05987 17.9176 4.318 17.6103 3.77101 17.0633C3.22402 16.5163 2.91672 15.7744 2.91672 15.0009V11.1258C3.55735 11.464 4.26755 11.6494 4.99175 11.6675C5.92679 11.6601 6.82383 11.2965 7.50013 10.6508C8.16921 11.3024 9.06624 11.667 10.0002 11.667C10.9341 11.667 11.8311 11.3024 12.5002 10.6508C13.1765 11.2965 14.0735 11.6601 15.0086 11.6675C15.7328 11.6494 16.443 11.464 17.0836 11.1258V15.0009ZM17.8953 7.36907L16.9886 4.64819C16.7404 3.90111 16.263 3.25124 15.6244 2.79092C14.9858 2.3306 14.2183 2.08324 13.4311 2.08399H6.56928C5.78203 2.08324 5.01457 2.3306 4.37593 2.79092C3.73729 3.25124 3.25995 3.90111 3.01172 4.64819L2.10504 7.36907C2.09079 7.41151 2.08348 7.45597 2.08337 7.50074C2.08337 8.27286 2.38952 9.01348 2.93471 9.56023C3.4799 10.107 4.21964 10.4152 4.99175 10.4175C5.47483 10.4156 5.95127 10.3048 6.38557 10.0933C6.81988 9.88177 7.20086 9.57498 7.50013 9.19577C7.79697 9.5762 8.17665 9.88395 8.61029 10.0956C9.04393 10.3073 9.52012 10.4173 10.0027 10.4173C10.4852 10.4173 10.9614 10.3073 11.395 10.0956C11.8287 9.88395 12.2084 9.5762 12.5052 9.19577C12.804 9.57427 13.1842 9.88064 13.6176 10.0921C14.0509 10.3036 14.5264 10.4148 15.0086 10.4175C15.7807 10.4152 16.5204 10.107 17.0656 9.56023C17.6108 9.01348 17.917 8.27286 17.917 7.50074C17.9169 7.45597 17.9095 7.41151 17.8953 7.36907Z"
          fill="white"
        />
      </svg>
    ),
  },
];
